const MIN_FRACTION_DIGITS_WHOLE_NUMBERS = 0;
const MIN_FRACTION_DIGITS_DECIMAL_NUMBERS = 2;
const REGEX_FIND_EURO_SIGN_OPTIONAL_SPACE = /^(\D\s?)/u;
const getCorrectedPriceCurrency = (price, language, minFractionDigits) => Intl.NumberFormat(language, {
    currency: 'EUR',
    style: 'currency',
    minimumFractionDigits: minFractionDigits ||
        (price % 1 == 0
            ? MIN_FRACTION_DIGITS_WHOLE_NUMBERS
            : MIN_FRACTION_DIGITS_DECIMAL_NUMBERS),
}).format(Math.abs(price));
const getCorrectedCurrency = (price, language, minFractionDigits) => getCorrectedPriceCurrency(price, language, minFractionDigits)
    .replace('€', '')
    .trim();
const getCorrectedPrice = (price, language, minFractionDigits) => getCorrectedPriceCurrency(price, language, minFractionDigits).replace(REGEX_FIND_EURO_SIGN_OPTIONAL_SPACE, price >= 0 ? '€\u00a0' : '– €\u00a0');

export { getCorrectedPrice as a, getCorrectedCurrency as g };
